import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";

/**
 * Shared shell for static / legal pages.
 * Keeps typography editorial and consistent with the rest of StyleMe.
 */
export const LegalShell = ({ eyebrow, title, children }) => (
  <div className="min-h-screen bg-[#0F0E13] text-[#F7F5F2]">
    <div className="max-w-3xl mx-auto px-6 py-16 lg:py-24">
      <div className="flex items-center justify-between mb-16">
        <Link to="/" className="flex items-center gap-2" data-testid="legal-logo-link">
          <Sparkles className="w-4 h-4 text-[#E3C2B0]" strokeWidth={1.5} />
          <span className="font-serif text-2xl">StyleMe</span>
        </Link>
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-[#A8A6A1] hover:text-[#F7F5F2]"
        >
          <ArrowLeft className="w-3 h-3" strokeWidth={1.5} /> Back
        </Link>
      </div>

      <span className="text-xs uppercase tracking-[0.4em] text-[#E3C2B0]">{eyebrow}</span>
      <h1 className="font-serif text-5xl lg:text-6xl mt-4 font-light leading-[1.05]">{title}</h1>

      <div className="mt-12 space-y-8 text-[15px] leading-relaxed text-[#D6D3CE] [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:text-[#F7F5F2] [&_h2]:mt-12 [&_h2]:mb-4 [&_h2]:font-light [&_a]:text-[#E3C2B0] [&_a:hover]:text-[#F0D4C5] [&_a]:underline [&_a]:underline-offset-4 [&_ul]:space-y-2 [&_ul]:list-disc [&_ul]:pl-6 [&_p]:text-[#D6D3CE]">
        {children}
      </div>

      <div className="mt-24 pt-8 border-t border-white/10 text-xs uppercase tracking-[0.3em] text-[#A8A6A1]">
        Last updated · 27 May 2026 · StyleMe by Sri Chandra B
      </div>
    </div>
  </div>
);

export default LegalShell;
